import styled from '@emotion/styled';

import {
  helperLinkReset,
  media,
  helperTextEllipsis,
  helperTypographyTitle,
  helperTypographyText,
} from '@utex/ui-kit';

export const Container = styled('a')`
  ${helperLinkReset};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2.6rem;
  margin-bottom: 2rem;

  @media ${media.phonablet} {
    flex-direction: row;
    padding-left: 1.8rem;
    padding-right: 4rem;
  }
`;

export const Name = styled('p')`
  ${helperTextEllipsis};
  ${helperTypographyTitle({ size: 'L' })};
  max-width: 100%;
  margin-top: 1rem;
  margin-bottom: 0;

  @media ${media.phonablet} {
    margin: 0 0 0 1.5rem;
    font-size: 1.5rem;
  }
`;

export const Email = styled('p')`
  ${helperTextEllipsis};
  ${helperTypographyText({
    view: 'hint',
    size: 'S-Compact-Height',
  })}
  max-width: 100%;
  margin-top: 0;
  margin-bottom: 0;

  @media ${media.phonablet} {
    display: none !important;
  }
`;
